import React, { useEffect, useState } from "react";
import { project, projectAccess } from "../../../system/types/project/project";
import { initialProject } from "../../../system/initial/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { dispatch } from "../../../App";
import { actions } from "../../../redux";
import { TextInput } from "../../FormElements/TextInput";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { mdiClipboardCheckOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslations } from "../../../hooks/useTranslations";

const EditProjectKey = () => {

    const { t } = useTranslations();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);

    const [projectId, setProjectId] = useState<string>('');
    const [commandId, setCommandId] = useState<string>('');

    const [editAccess, setEditAccess] = useState<projectAccess>({
        token: '',
        domain: '',

    });

    const [domainAccess, setDomainAccess] = useState<string>('');

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }
        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }
        if (state.project.pageCommandId !== commandId) {
            setCommandId(state.project.pageCommandId);
        }

    });

    const changeDomainAccess = (input: string) => {
        setDomainAccess(input);
    }

    const save = async () => {
        const accessList: projectAccess[] = [];
        let tokenFound: boolean = false;
        projectData.access.forEach((access) => {
            if (access.token === commandId) {
                accessList.push({
                    token: commandId,
                    domain: domainAccess,
                });
                tokenFound = true;
                return;
            }
            accessList.push(access);
        });

        if (!tokenFound) {
            accessList.push({
                token: commandId,
                domain: domainAccess,
            });
        }


        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProjectAccess(projectId, accessList);

        if (result._id) {
            dispatch(actions.project.setData(result))

            if (commandId !== '') {
                return;
            }

            const list = result.access;
            const entry = list[list.length - 1];
            dispatch(actions.project.setPageCommandId(entry.token));
        }

    };

    const deleteEntry = async () => {
        const userConfirmed = window.confirm(t('projects.confirmremoveapikey'));

        if (!userConfirmed){
            return;
        }

        const accessList: projectAccess[] = [];
        projectData.access.forEach((access) => {
            if (access.token !== commandId) {
                return;
            }
            accessList.push(access);
        });

        const api = new ProjectApi(sessionToken, sessionEmail);
        const result = await api.saveProjectAccess(projectId, accessList);

        if (result._id) {
            dispatch(actions.project.setData(result))
            dispatch(actions.project.setPageCommand(''));
        }
    };

    const cancel = () => {
        dispatch(actions.project.setPageCommand(''));
    };

    const copyKeyClipboard = () => {
        navigator.clipboard.writeText(commandId).then(
            () => {
            },
            (err) => {
              console.error("Fehler beim Kopieren in die Zwischenablage: ", err);
            }
          );
    };


    useEffect(() => {
        projectData.access.forEach((access) => {
            if (access.token === commandId) {
                setEditAccess(access);
                return;
            }
        });

    }, [projectData, commandId]);

    useEffect(() => {
        setDomainAccess(editAccess.domain);
    }, [editAccess])



    return (
        <div className="container-float px-3 py-3">
            <div className="row mb-3 align-items-center">
                <div className="col"><h2>{commandId === '' ? t('projects.newaccesskey') : t('projects.accesskey')} &nbsp;</h2></div>
                <div className="col-auto"><button onClick={save} className="btn btn-outline-success">{t('common.save')}</button></div>
                {commandId !== '' ?
                    <div className="col-auto"><button onClick={deleteEntry} className="btn btn-outline-danger">{t('common.remove')}</button></div>
                    : null}
                <div className="col-auto"><button onClick={cancel} className="btn btn-outline-danger">{t('common.cancel')}</button></div>
            </div>
            {commandId !== '' ?
                <div className="row mb-3">
                    <div className="col-11"><span className="keyShow">{commandId}</span></div>
                    <div className="col-1"><span className="link" onClick={copyKeyClipboard}><Icon path={mdiClipboardCheckOutline} size={1}/></span></div>
                </div>
                : null}
            <div className="row mb-3">
                <div className="col">
                    <TextInput
                        name="domainAccess"
                        value={domainAccess}
                        label={t('projects.domainrestriction')}
                        onChange={changeDomainAccess}
                        placeholder={t('projects.emptynorestriction')}
                    ></TextInput>
                </div>
            </div>

        </div>
    );
}

export { EditProjectKey };

